import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import useProductBasicDetails from 'data-hooks/useProductBasicDetails';
import useProductAttributes from 'data-hooks/useProductAttributes';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import QuickViewModalUI from './QuickViewModalUI';
import QuickViewModalEvents from './QuickViewModalEvents';
import useProductDimensions from './hooks/useProductDimensions';
import usePDPUrl from './hooks/usePDPUrl';
import PDPContext from '../PDP/state/context/PDPContext';
import usePDPCreateContextValue from '../PDP/hooks/usePDPCreateContextValue';
const QuickViewModal = t0 => {
  const $ = _c(42);
  const {
    isOpen,
    onClose,
    path,
    slug,
    variantSku: t1
  } = t0;
  const variantSku = t1 === undefined ? "" : t1;
  const isModalOpen = isOpen && !!slug;
  const skip = !isModalOpen;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== skip) {
    t3 = {
      skip
    };
    $[1] = skip;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data
  } = useProductBasicDetails(null, slug, t2, t3);
  const dimensions = useProductDimensions(null, slug, skip);
  let t4;
  if ($[3] !== data) {
    t4 = data ?? {};
    $[3] = data;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    name: t5
  } = t4;
  const name = t5 === undefined ? "" : t5;
  let t6;
  if ($[5] !== data) {
    t6 = data ?? {};
    $[5] = data;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    id: t7
  } = t6;
  const productId = t7 === undefined ? "" : t7;
  const {
    data: t8
  } = useProductAttributes(null, slug, skip);
  const {
    description: headline,
    additional_attributes
  } = t8;
  const description = additional_attributes?.showpiece_desc;
  let t9;
  if ($[7] !== path || $[8] !== skip || $[9] !== slug) {
    t9 = {
      path,
      skip,
      slug
    };
    $[7] = path;
    $[8] = skip;
    $[9] = slug;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const pathWithQuery = usePDPUrl(t9);
  const history = useHistory();
  let t10;
  if ($[11] !== history || $[12] !== onClose || $[13] !== path) {
    t10 = path && history ? () => {
      onClose();
      history.push(path);
    } : undefined;
    $[11] = history;
    $[12] = onClose;
    $[13] = path;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const onMoreMaterialsClick = t10;
  let t11;
  if ($[15] !== slug || $[16] !== variantSku) {
    t11 = {
      isQuickView: true,
      pdpVariantSkuOverride: variantSku,
      slug
    };
    $[15] = slug;
    $[16] = variantSku;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== skip) {
    t12 = {
      skip
    };
    $[18] = skip;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const pdpContextValue = usePDPCreateContextValue(t11, t12);
  const selectedOptionsVariantSku = pdpContextValue?.productOptions.data?.selectedOptionsVariantSku;
  const variantSkuFlashSale = !!pdpContextValue?.productOptions?.data?.stock?.variantSkuFlashSale?.[selectedOptionsVariantSku];
  const t13 = headline || description;
  const t14 = !!pdpContextValue?.stockAvailability?.data?.isOutOfStock;
  let t15;
  if ($[20] !== dimensions || $[21] !== isOpen || $[22] !== name || $[23] !== onClose || $[24] !== onMoreMaterialsClick || $[25] !== pathWithQuery || $[26] !== productId || $[27] !== slug || $[28] !== t13 || $[29] !== t14) {
    t15 = <QuickViewModalUI description={t13} dimensions={dimensions} isOpen={isOpen} isOutOfStock={t14} name={name} onClose={onClose} onMoreMaterialsClick={onMoreMaterialsClick} path={pathWithQuery} productId={productId} slug={slug} />;
    $[20] = dimensions;
    $[21] = isOpen;
    $[22] = name;
    $[23] = onClose;
    $[24] = onMoreMaterialsClick;
    $[25] = pathWithQuery;
    $[26] = productId;
    $[27] = slug;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== data || $[32] !== isModalOpen || $[33] !== productId || $[34] !== selectedOptionsVariantSku || $[35] !== slug || $[36] !== variantSkuFlashSale) {
    t16 = isModalOpen === true && <QuickViewModalEvents productId={productId} product={data} slug={slug} selectedOptionsVariantSku={selectedOptionsVariantSku} variantSkuFlashSale={variantSkuFlashSale} />;
    $[31] = data;
    $[32] = isModalOpen;
    $[33] = productId;
    $[34] = selectedOptionsVariantSku;
    $[35] = slug;
    $[36] = variantSkuFlashSale;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== pdpContextValue || $[39] !== t15 || $[40] !== t16) {
    t17 = <PDPContext.Provider value={pdpContextValue}>{t15}{t16}</PDPContext.Provider>;
    $[38] = pdpContextValue;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
QuickViewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  path: PropTypes.string,
  slug: PropTypes.string,
  variantSku: PropTypes.string
};
export default withBrowserOnly(QuickViewModal);